import React from 'react';

export default function Tab({ children }) {
  return <div className="tab-content-containter p-4 bg-white rounded-b">{children}</div>;
}
